<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card style="display:none">
        <v-card-title>Lower Security Mode Options</v-card-title>
        <span v-if="org!=null"><center><h3> {{org.name}}  </h3></center></span>
      <v-card-text>
          <video id="player" controls autoplay></video>
          <button id="capture" @click="takepic">Start Exam</button>
          <canvas id="canvas"  width=500 height=500></canvas>

      </v-card-text>
    </v-card>
    
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    color: "",
    org: null,
    //
    player:null,
   // capture:null,
    canvas:null,
    timer:"",
    interval:6000,
    les:{id:0},
  }),
  watch: {
    
  },
  beforeDestroy () {
    console.log("destroy")
    clearInterval(this.timer)
    if(this.player!=null)
      this.player.src=null;
    console.log("player stop")
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    callProc(){
      //this.takepic()
      console.log("init:"+this.interval)
      this.timer = setInterval(this.takepic, this.interval)
    },
    takepic()
    {
       this.context.drawImage(this.player, 0, 0,this.canvas.width, this.canvas.height);
       this.saveimage();
       console.log("calling:"+this.interval)
       //this.timer = setTimeout(this.takepic(), 5000)  //it is in miliseconds... currently set to 5 secs
       
    },
    stop(){
      console.log("stop")
      clearInterval(this.timer)
    },
    srcToFile(src, fileName, mimeType){
      return (fetch(src)
          .then(function(res){return res.arrayBuffer();})
          .then(function(buf){return new File([buf], fileName, {type:mimeType});})
      );
    },
    saveimage()
    {
        var image 
        if(document.getElementById("canvas")!=null)
          image = document.getElementById("canvas").toDataURL("image/png");
        else 
          return  
        const lesid = this.les.les_id
        console.log(image)
        this.srcToFile(image, 'logo.png', 'image/png')
        .then(function(file){
            console.log("file....."+file.size)
            var fd = new FormData();
            fd.append('doc', file);
           
            fd.append('les',lesid );
            axios.post( 'student/pushImage',
            fd,
            {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
            }
                ).then(function(){
            console.log('SUCCESS!!');
            })
            .catch(function(){
            console.log('FAILURE!!');
            });
            //return fetch('/upload.php', {method:'POST', body:fd});
        })
        .then(function(res){
            //console.log(res)
            //return res.text();
        })
        .then()
        .catch()
        ;
       // var ajax = new XMLHttpRequest();
        // ajax.open("POST","http://localhost:8080/LearnerExamProctoringLog/upload",false);
        // ajax.setRequestHeader("Content-Type", "application/upload");
        // ajax.send(image);
    }

  },
 
  mounted() {
    if (localStorage.getItem("stud_ques_ans_list") == "") {
      this.$router.push({ name: "stud-start-exam" });
      return;
    }
    this.interval = parseInt(localStorage.getItem("interval"))
    this.les = JSON.parse(localStorage.getItem("les"));
    console.log("les:"+this.les.les_id)
    this.player = document.getElementById('player');
    this.canvas = document.getElementById('canvas');
    this.context = canvas.getContext('2d');
    const captureButton = document.getElementById('capture');
    const constraints = {
      video: true,
    };
  // Attach the video stream to the video element and autoplay.
  navigator.mediaDevices.getUserMedia(constraints)
    .then((stream) => {
      player.srcObject = stream;
      this.callProc()
      //this.timer = setInterval(this.takepic(), this.interval)
      
    });
   
  }
  
};

</script>

